import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const IndustriesLuxury = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('reveal-show'); });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return (
    <>
      <div className="business-hero" style={{ background: 'linear-gradient(135deg, #78350f, #d97706)' }}>
        <div className="hero-content">
          <h1 className="hero-title reveal-text">Luxury & Retail</h1>
          <p className="hero-subtitle reveal-text delay-1">Premium jewelry and exceptional retail experiences crafted with elegance</p>
        </div>
      </div>
      <div className="business-wrapper">
        <div className="container">
          <div className="category">
            <div className="category-header gold"><h2>Our Luxury Brand</h2><p>Exquisite craftsmanship and timeless designs</p></div>
            <div className="card-grid">
              <div className="business-card gold reveal-card"><h3>AALI GOLD JEWELZ</h3><p>Premium jewelry brand offering exquisite designs crafted with the finest materials</p><Link to="/companies/aaligoldjewelz">Know More →</Link></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default IndustriesLuxury;